module.exports = __webpack_public_path__ + "static/media/prizm-snow-poster.5e839cfe.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/screens/prizm/prizm-snow-poster.jpg
// module id = 3542
// module chunks = 0